import { ICommentInput, IUploadReceipt } from './interface';

export class UploadReceipt {
    static readonly type = '[Requests] upload-receipt';
    constructor(public input: IUploadReceipt) {}
}
export class AddRequestComment {
    static readonly type = '[Requests] comment';
    constructor(public input: ICommentInput) {}
}

export class GetApprovers {
    static readonly type = '[Requests] get-approver';
}
